import classNames from 'classnames';
import React from 'react';
import { Theme } from '../../types';
import Size from '../../types/enum/Size';
import './Icon.scss';
import IIconProps from './IconProps';

function getIconSize(size: IIconProps['size']) {
  switch (size) {
    case 'xs':
      return 12;
    case Size.SMALL:
      return 16;
    case Size.MEDIUM:
      return 24;
    case Size.LARGE:
      return 36;
    case Size.XL:
      return 56;
    case Size.GROW:
      return '100%';
    default:
      return size;
  }
}

function getThemeClass(theme: IIconProps['theme']) {
  switch (theme) {
    case 'light-gray':
      return 'icon-light-gray';
    default:
      if (theme) {
        return `icon-${theme}`;
      }
      return null;
  }
}

const Icon = ({ svg, size, theme, className }: IIconProps) => {
  const iconSize = getIconSize(size);

  return React.createElement(svg, {
    className: classNames('icon', className, getThemeClass(theme)),
    height: iconSize,
    width: iconSize,
  });
};

Icon.defaultProps = {
  size: Size.MEDIUM,
};

export default Icon;
